export default {
  CURRENT_USER ({ currentUser }) {
    return currentUser
  },
  ADMIN_ROLLE ({ adminRolle }) {
    return adminRolle
  },
  MITARBEITER_ADDRESS_ID ({ mitarbeiterAddressID }) {
    return mitarbeiterAddressID
  },
  VLAMS_USERS ({ vlamsUsers }) {
    return vlamsUsers
  }
}
